import * as React from 'react';
import equal from 'fast-deep-equal/react';
import { useSelector } from 'react-redux';
import styles from './Footer.scss';
import Account from '~/account/Account';
import { settings } from '~/utils/settings';
import { NavLink, useLocation } from 'react-router-dom';
import { urlsMap } from '~/utils/menu';
import { t } from '~/utils/localization';
import { hasCoupons, isCouponsTabHidden } from '~/utils/coupons';
import { State } from '~/Reducers';
import { ProductEntity } from '@wg/wows-commerce/core/entity/product.entity';
import { isRealMoneyPurchaseDisabled } from '~/utils/category';
import { CATEGORIES } from '~/const';
import classNames from 'classnames';

export const isActiveMenuItem = (url: string, location: string) => {
    if (!url) {
        return false;
    }

    if (url.includes(CATEGORIES.AUCTION)) {
        return location.includes(url);
    }

    if (location.includes(CATEGORIES.FEATURED)) {
        return `/${settings.languageCode}` === url;
    }

    return url === location || `${url}/` === location;
};

interface IStateSelector {
    shopUnavailable: boolean;
    shopProducts: ProductEntity[];
    menu: IMenuMap;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        shopUnavailable: state.ReducerWSMart.shopUnavailable,
        shopProducts: state.ReducerWSMart.products,
        menu: state.ReducerApp.menu,
    };
};

const MobileMenuFooter = () => {
    const location = useLocation();

    const account = Account.getAccount();
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const premiumCategory = state.menu?.[CATEGORIES.WSMART];

    const isAvailableShop = !state.shopUnavailable && !isRealMoneyPurchaseDisabled() && premiumCategory?.url;

    const menuItems = [
        {
            to: urlsMap.home,
            isAvailable: true,
            title: t('Главная'),
            codeName: 'home',
            iconClassName: styles.mobilePremiumMainIcon,
        },
        {
            to: urlsMap.mobileMenu,
            isAvailable: true,
            title: t('Категории'),
            codeName: 'categories',
            iconClassName: styles.mobileMenuIcon,
        },
        {
            to: urlsMap.coupons,
            isAvailable: !!account && hasCoupons() && !isCouponsTabHidden(),
            title: t('Купоны'),
            codeName: 'coupons',
            iconClassName: styles.userCouponsItem,
        },
        {
            to: premiumCategory?.url,
            isAvailable: isAvailableShop,
            title: t('Дублоны'),
            codeName: 'shop',
            iconClassName: styles.mobilePremiumShopIcon,
        },
        {
            to: urlsMap.wallet,
            isAvailable: !!account,
            title: t('Кошелёк'),
            item: 'wallet',
            iconClassName: styles.mobileWalletIcon,
        },
    ];

    return (
        <div className={styles.mobileStickyWrapper}>
            <div className={styles.mobileFixedMenu}>
                <div className={styles.mobileMenuContent}>
                    {menuItems.map((menuItem, index) => {
                        return (
                            menuItem.isAvailable && (
                                <NavLink
                                    to={menuItem.to}
                                    className={() => {
                                        return classNames(styles.mobileItemMenu, {
                                            [styles.active]: isActiveMenuItem(menuItem.to, location.pathname),
                                        });
                                    }}
                                    key={`mobile_menu_item_${menuItem.to}`}
                                >
                                    <div className={classNames(styles.mobileUserMenuItem, 'armory__auto--menu-footer')} data-menu-item={menuItem.codeName}>
                                        <div className={menuItem.iconClassName} />
                                        <div className={styles.mobileMenuTitle}>{menuItem.title}</div>
                                    </div>
                                </NavLink>
                            )
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default MobileMenuFooter;
